export function placeResponsiveFields(fields, columns) {
    const placed = fields.flatMap((field)=>{
        const small = field.layoutByBreakpoint?.small;
        return small ? [
            {
                field,
                small
            }
        ] : [];
    });
    if (placed.length < fields.length) {
        return new Map(fields.map((field, row)=>[
                field.id,
                {
                    large: toLargePlacement(field.layout),
                    small: {
                        column: 0,
                        width: columns,
                        row,
                        height: 1
                    }
                }
            ]));
    }
    // Rows a taller field spans count as taken, so packing never pulls the next
    // row up beside it.
    const ranks = denseRanks(placed.flatMap(({ small })=>occupiedRows(small)));
    return new Map(placed.map(({ field, small })=>[
            field.id,
            {
                large: toLargePlacement(field.layout),
                small: {
                    ...clampColumns(small, columns),
                    row: ranks.get(small.row),
                    height: toHeight(small)
                }
            }
        ]));
}
export function toResponsiveGridVariables({ large, small }) {
    const columnVariables = {
        '--form-col-lg': toColumn(large),
        '--form-col-sm': toColumn(small)
    };
    const offset = {
        '--form-row-offset-sm': small.row > 0 ? '1' : '0'
    };
    return {
        label: {
            ...columnVariables,
            ...offset,
            '--form-row-lg': toRow(large, 0, 1),
            '--form-row-sm': toRow(small, 0, 1)
        },
        input: {
            ...columnVariables,
            '--form-row-offset-sm': '0',
            '--form-row-lg': toRow(large, 1, 1),
            '--form-row-sm': toRow(small, 1, small.height * 2 - 1)
        },
        container: {
            ...columnVariables,
            ...offset,
            '--form-row-lg': toRow(large, 0, 2),
            '--form-row-sm': toRow(small, 0, small.height * 2)
        }
    };
}
const responsiveGridCache = new WeakMap();
export function getResponsiveGrid(form) {
    const cached = responsiveGridCache.get(form);
    if (cached) {
        return cached;
    }
    const placement = placeResponsiveFields(form.fields, form.grid.columns);
    const grid = {
        fields: new Map([
            ...placement
        ].map(([fieldId, fieldPlacement])=>[
                fieldId,
                toResponsiveGridVariables(fieldPlacement)
            ]))
    };
    responsiveGridCache.set(form, grid);
    return grid;
}
function denseRanks(rows) {
    return new Map([
        ...new Set(rows)
    ].sort((one, other)=>one - other).map((row, rank)=>[
            row,
            rank
        ]));
}
function toLargePlacement({ column, width }) {
    return {
        column,
        width,
        row: 0,
        height: 1
    };
}
function toHeight({ height }) {
    return height > 1 ? height : 1;
}
function occupiedRows(layout) {
    return Array.from({
        length: toHeight(layout)
    }, (_, index)=>layout.row + index);
}
function clampColumns({ column, width }, columns) {
    const clampedColumn = Math.min(Math.max(column, 0), columns - 1);
    return {
        column: clampedColumn,
        width: Math.min(Math.max(width, 1), columns - clampedColumn)
    };
}
function toColumn({ column, width }) {
    return `${column + 1} / span ${width}`;
}
function toRow({ row }, track, span) {
    return `${row * 2 + track + 1} / span ${span}`;
}

//# sourceMappingURL=responsive-grid.js.map